import React from 'react';
import _data from '../../data';
import { SRLWrapper } from 'simple-react-lightbox';
import SimpleReactLightbox from 'simple-react-lightbox';

export default class Pricing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: {},
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */

    this.setState({
      price: _data.price,
    });
  }

  renderUniqueContent(sectionIndex) {
const contents = [
  {
    title: "Step 1: Pack the Bottom (Light + Bulky Items)",
    description: (
      <>
        <img src="/img/how-to-pack-hiking-backpack-diagram/how-to-pack-hiking-backpack-diagram.svg" alt="How to Pack a Hiking Backpack Diagram" loading="lazy" />
      </>
    )
  },
  {
    title: "Step 1: Pack the Bottom (Light + Bulky Items)",
    description: (
      <>
        <p>
          Start by packing the bottom of your hiking backpack with light and bulky items you won’t need during the day.
        </p>

        <p>
          This includes a sleeping bag, sleeping pad, and extra clothes. These items are soft and compressible,
          creating a stable base that supports the rest of your gear.
        </p>

        <p>
          Keeping lightweight gear at the bottom helps improve weight distribution and prevents your backpack
          from feeling unbalanced on the trail.
        </p>

        <p>
          Think of this layer as your foundation — light, soft, and only needed once you reach camp.
        </p>
      </>
    )
  },

  {
    title: "Step 2: Pack the Middle (Heavy Items Close to Your Back)",
    description: (
      <>
        <p>
          The middle of your backpack is the most important area for proper weight distribution.
        </p>

        <p>
          Place heavy items like your water reservoir, food, and cooking gear here, making sure they are
          centered and positioned close to your back.
        </p>

        <p>
          This helps maintain your natural center of gravity, reduces strain on your shoulders,
          and improves balance on uneven terrain.
        </p>

        <p>
          If you only remember one rule, this is it: keep heavy items close to your spine.
        </p>
      </>
    )
  },

  {
    title: "Step 3: Fill the Middle Outer Area (Medium-Weight Gear)",
    description: (
      <>
        <p>
          Once your heavy items are in place, fill the surrounding space with medium-weight gear.
        </p>

        <p>
          Pack items like extra layers, a rain jacket, and a first aid kit around your core gear.
        </p>

        <p>
          This step removes empty space inside your backpack and prevents items from shifting while you hike.
        </p>

        <p>
          A tight, well-packed backpack feels significantly more stable and comfortable over long distances.
        </p>
      </>
    )
  },

  {
    title: "Step 4: Pack the Top (Quick Access Essentials)",
    description: (
      <>
        <p>
          The top of your hiking backpack should be reserved for items you need throughout the day.
        </p>

        <p>
          This includes snacks, sunscreen, gloves, a headlamp, and navigation tools like a map or GPS.
        </p>

        <p>
          Keeping these essentials on top allows you to grab them quickly without unpacking your entire bag.
        </p>

        <p>
          Easy access saves time and keeps your hike smooth and efficient.
        </p>
      </>
    )
  },

  {
    title: "Step 5: Use External Pockets for Easy Access",
    description: (
      <>
        <p>
          External pockets are perfect for items you want to access quickly without opening your main compartment.
        </p>

        <p>
          Use them for water bottles, trekking poles, wet gear, or trash.
        </p>

        <p>
          This keeps your main compartment organized while making essential items easy to reach during your hike.
        </p>

        <p>
          Smart use of outer pockets improves both convenience and overall organization.
        </p>
      </>
    )
  },

  {
    title: "Step 6: Adjust Your Backpack for Proper Weight Distribution",
    description: (
      <>
        <p>
          Once your backpack is fully packed, adjusting it correctly is just as important as how you packed it.
        </p>

        <p>
          Tighten compression straps to stabilize the load, adjust your shoulder straps,
          and secure the hip belt snugly around your hips.
        </p>

        <p>
          Most of the weight should sit on your hips — not your shoulders.
        </p>

        <p>
          Proper adjustment reduces fatigue, improves comfort, and prevents strain on long hikes.
        </p>
      </>
    )
  },

  {
    title: "Common Backpack Packing Mistakes to Avoid",
    description: (
      <>
        <p>
          Even small packing mistakes can make your backpack feel much heavier than it actually is.
        </p>

        <p>
          Avoid placing heavy items far from your back, overpacking unnecessary gear,
          leaving empty space inside your pack, or storing frequently used items too deep.
        </p>

        <p>
          These mistakes lead to poor balance, shifting weight, and increased fatigue on the trail.
        </p>

        <p>
          Packing your backpack correctly makes a huge difference in comfort, stability, and overall hiking experience.
        </p>
      </>
    )
  }
];

    const content = contents[sectionIndex % contents.length];

return (
  <div className="col-12">
    <div
      style={{
        maxWidth: "820px",
        margin: "40px auto",
        padding: "40px",
        background: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 8px 30px rgba(0,0,0,0.05)"
      }}
    >
      <h2 style={{ fontSize: "30px", marginBottom: "20px" }}>
        {content.title}
      </h2>

      <div style={{ fontSize: "18px", lineHeight: "1.8", color: "#555", width: "100%" }}>
        {content.description}
      </div>
    </div>
  </div>
);
  }

 render() {
    return (
      <React.Fragment>
        <div className="overflow-hidden">
          <section
            id="chain-lakes-loop-pricing"
            className={
              'package-section ptb-55 ' +
              (this.props.bgColor && this.props.bgColor === 'gray'
                ? 'gray-light-bg'
                : 'background-shape-right')
            }
          >
            <div className="container">
              <div className="row justify-content-center">
                {!this.props.hidePackages && (this.state.price. howToPlanSustainableHikingTripPackages || []).map((_package, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="col-lg-4 col-md">
                        <div
                          className={
                            'card text-center single-pricing-pack ' +
                            (_package.isFeatured ? 'popular-price' : '')
                          }
                        >
                          <div className="pt-4">
                            <h2 className="small-heading">{_package.license}</h2>
                          </div>
                          <div className="pricing-img mt-4">
                            <img
                              src={_package.photoImg}
                              alt={_package.photoImg}
                              className="img-fluid"
                            loading="lazy" />
                          </div>
                          <div className="card-header py-4 border-0 pricing-header">
                            <div className="p text-center mb-0 small-heading">
                              <span className="price font-weight-bolder">
                                {_package.price}
                              </span>
                            </div>
                          </div>
                          <div className="card-body">
                            <ul className="list-unstyled text-sm mb-4 pricing-feature-list">
                              {(_package.features || []).map((feature) => {
                                return <li key={feature}>{feature}</li>;
                              })}
                            </ul>

                            <a
                              href={_package.fareharborURL}
                              className={
                                'btn mb-3 ' +
                                (_package.isFeatured
                                  ? 'trip-solid-btn'
                                  : 'trip-outline-btn')
                              }
                            >
                            </a>
                          </div>
                        </div>
                      </div>
                </React.Fragment>
                );
                })}
                </div>

                <div className="row">
                  {[0, 1, 2, 3,4,5,6, 7].map((i) => (
                    <React.Fragment key={i}>
                      {this.renderUniqueContent(i)}
                    </React.Fragment>
                  ))}
                </div>
              {!(this.props.hideFaq && this.props.hideFaq === true) &&
                this.props.theme !== 'four' && (
                <div className="mt-5">
  <div className="col-12 text-center mb-lg-5">
    <h2>Hiking Backpack Packing FAQs</h2>
  </div>
  <div className="col-12">
    <div id="accordion-1" className="accordion accordion-faq">

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q1">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            What is the best way to pack a hiking backpack for comfort?
          </h3>
        </div>
        <div id="q1" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              The best way to pack a hiking backpack is to place heavy items like food and water close to your back, keep light gear at the bottom, and store frequently used items on top or in outer pockets. This improves balance, reduces strain, and makes your backpack feel lighter.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q2">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            How should weight be distributed in a hiking backpack?
          </h3>
        </div>
        <div id="q2" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              Weight should be distributed with heavy items in the middle of the backpack close to your spine, medium-weight items around them, and light gear at the bottom. Proper weight distribution improves stability and prevents back and shoulder pain.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q3">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            Where do you put a sleeping bag in a hiking backpack?
          </h3>
        </div>
        <div id="q3" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              A sleeping bag should be placed at the bottom of your hiking backpack. This area is ideal for light, bulky items that you won’t need during the day and helps create a stable base for heavier gear above.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q4">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            Should heavy items be high or low in a backpack?
          </h3>
        </div>
        <div id="q4" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              Heavy items should be packed in the middle of your backpack close to your back—not too high or too low. This keeps your center of gravity stable and prevents the pack from pulling you backward.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q5">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            What should you pack at the top of a hiking backpack?
          </h3>
        </div>
        <div id="q5" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              The top of your backpack should hold frequently used items like snacks, sunscreen, gloves, a headlamp, and navigation tools so you can access them quickly without unpacking everything.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q6">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            Why does my backpack feel heavier than it actually is?
          </h3>
        </div>
        <div id="q6" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              A backpack feels heavier when weight is poorly distributed or items shift inside the pack. Keeping heavy items close to your back and eliminating empty space helps your pack feel lighter and more stable.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q7">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            How tight should backpack straps be when hiking?
          </h3>
        </div>
        <div id="q7" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              Backpack straps should be snug but comfortable. The hip belt should carry about 70 to 80 percent of the weight, while shoulder straps stabilize the load and compression straps prevent shifting.
            </p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-4" data-toggle="collapse" data-target="#q8">
          <h3 className="mb-0">
            <span className="ti-direction-alt mr-3"></span>
            How heavy should a hiking backpack be?
          </h3>
        </div>
        <div id="q8" className="collapse" data-parent="#accordion-1">
          <div className="card-body">
            <p>
              A hiking backpack for a day hike should weigh about 10 to 20 percent of your body weight. Keeping your pack within this range helps reduce fatigue and improves overall comfort on the trail.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
                )}
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}
